"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchAcceptNotificationEvent = void 0;
var _acceptNotification = require("@ori-events/accept-notification");
const dispatchAcceptNotificationEvent = reasonId => {
  const acceptNotificationEvent = new CustomEvent(_acceptNotification.Name, {
    detail: {
      reasonId
    }
  });
  window.dispatchEvent(acceptNotificationEvent);
};
exports.dispatchAcceptNotificationEvent = dispatchAcceptNotificationEvent;